import { createContext, useContext } from "react";
import { emptyObject } from "../../redux/utils";

export const devModeConfig = {
  template: {
    explorerCaption: 'Templates',
    controllerName: 'templates',
    type: 'template',
    idFolder: '#_folder_template',
    fontColor: 'peachpuff',
  },
  primitiva: {
    explorerCaption: 'Servicios',
    controllerName: 'primitivas',
    type: 'primitiva',
    idFolder: '#_folder_primitiva',
    fontColor: 'lightblue',
  },
  operacion: {
    explorerCaption: 'Orquestadores',
    controllerName: 'operaciones',
    type: 'operacion',
    idFolder: '#_folder_operacion',
    fontColor: 'lightgreen',
  },
  captions: {
    APP: 'PROYECTO',
    OPEN_TABS: 'EDITORES ABIERTOS',
  },
  ids: {
    APP: '#folder_PROYECTO',
    OPEN_TABS: '#folder_EDITORES_ABIERTOS',
  }
}

export const DevModeContext = createContext(emptyObject);
export const useDevModeContext = () => useContext(DevModeContext);

export const defaultData = {
  name: 'ROOT',
  id:'ROOT',
  isBranch: true,
  children: [
    {
      name: devModeConfig.captions.OPEN_TABS,
      id: devModeConfig.ids.OPEN_TABS,
      isBranch: true,
      children: [],
    },
    {
      name: devModeConfig.captions.APP,
      id: devModeConfig.ids.APP,
      isBranch: true,
      children: [
        {
          name: devModeConfig.template.explorerCaption,
          id: devModeConfig.template.idFolder,
          children: [],
          isBranch: true,
        },
        {
          name: devModeConfig.primitiva.explorerCaption,
          id: devModeConfig.primitiva.idFolder,
          children: [],
          isBranch: true,
        },
        {
          name: devModeConfig.operacion.explorerCaption,
          id: devModeConfig.operacion.idFolder,
          children: [],
          isBranch: true,
        }
      ]
    }
  ]
};

export const defaultGridItemsState = {
  "lg": [
      // {
      //     "key": "library",
      //     "show": true,
      //     "content": "ElementLibrary",
      //     "scrollable": true,
      //     "title": "Libreria de elementos",
      //     "canClose": true,
      //     "dataGrid": {
      //         "w": 5,
      //         "h": 14,
      //         "x": 0,
      //         "y": 0,
      //         "i": "library",
      //         "moved": false,
      //         "static": false
      //     }
      // },
      {
          "key": "explorer",
          "show": true,
          "content": "ProjectExplorer",
          "scrollable": true,
          "title": "Explorador",
          "canClose": true,
          "dataGrid": {
              "w": 5,
              "h": 14,
              "x": 0,
              "y": 0,
              "i": "explorer",
              "moved": false,
              "static": false
          }
      },
      {
          "key": "navigator",
          "show": true,
          "content": "Navigator",
          "scrollable": true,
          "title": "Navegador",
          "canClose": true,
          "dataGrid": {
              "w": 5,
              "h": 29,
              "x": 19,
              "y": 0,
              "i": "navigator",
              "moved": false,
              "static": false
          }
      },
      {
          "key": "editor",
          "show": true,
          "content": "FileTabs",
          "scrollable": true,
          "title": "Editor",
          "canClose": false,
          "dataGrid": {
              "w": 14,
              "h": 29,
              "x": 5,
              "y": 0,
              "i": "editor",
              "moved": false,
              "static": false
          }
      },
      {
          "key": "properties",
          "show": true,
          "content": "FilePropertiesWrapper",
          "scrollable": true,
          "title": "Propiedades",
          "canClose": false,
          "dataGrid": {
              "w": 5,
              "h": 15,
              "x": 0,
              "y": 14,
              "i": "properties",
              "moved": false,
              "static": false
          }
      }
  ],
  "md": [
      {
          "key": "explorer",
          "show": true,
          "content": "ProjectExplorer",
          "scrollable": true,
          "title": "Explorador",
          "canClose": true,
          "dataGrid": {
              "w": 6,
              "h": 13,
              "x": 0,
              "y": 0,
              "i": "explorer",
              "moved": false,
              "static": false
          }
      },
      {
          "key": "navigator",
          "show": false,
          "content": "Navigator",
          "scrollable": true,
          "title": "Navegador",
          "canClose": true,
          "dataGrid": {
              "w": 6,
              "h": 16,
              "x": 0,
              "y": 13,
              "i": "navigator",
              "moved": false,
              "static": false
          }
      },
      {
          "key": "editor",
          "show": true,
          "content": "FileTabs",
          "scrollable": true,
          "title": "Editor",
          "canClose": false,
          "dataGrid": {
              "w": 14,
              "h": 29,
              "x": 6,
              "y": 0,
              "i": "editor",
              "moved": false,
              "static": false
          }
      },
      {
          "key": "properties",
          "show": true,
          "content": "FilePropertiesWrapper",
          "scrollable": true,
          "title": "Propiedades",
          "canClose": false,
          "dataGrid": {
              "w": 6,
              "h": 16,
              "x": 0,
              "y": 13,
              "i": "properties",
              "moved": false,
              "static": false
          }
      }
  ],
  "sm": [
      {
          "key": "explorer",
          "show": true,
          "content": "ProjectExplorer",
          "scrollable": true,
          "title": "Explorador",
          "canClose": true,
          "dataGrid": {
              "w": 4,
              "h": 12,
              "x": 0,
              "y": 0,
              "i": "explorer",
              "moved": false,
              "static": false
          }
      },
      {
          "key": "navigator",
          "show": false,
          "content": "Navigator",
          "scrollable": true,
          "title": "Navegador",
          "canClose": true
      },
      {
          "key": "editor",
          "show": true,
          "content": "FileTabs",
          "scrollable": true,
          "title": "Editor",
          "canClose": false,
          "dataGrid": {
              "w": 8,
              "h": 29,
              "x": 4,
              "y": 0,
              "i": "editor",
              "moved": false,
              "static": false
          }
      },
      {
          "key": "properties",
          "show": true,
          "content": "FilePropertiesWrapper",
          "scrollable": true,
          "title": "Propiedades",
          "canClose": false,
          "dataGrid": {
              "w": 4,
              "h": 17,
              "x": 0,
              "y": 12,
              "i": "properties",
              "moved": false,
              "static": false
          }
      }
  ],
  "xs": [
      {
          "key": "explorer",
          "show": true,
          "content": "ProjectExplorer",
          "scrollable": true,
          "title": "Explorador",
          "canClose": true,
          "dataGrid": {
              "w": 3,
              "h": 9,
              "x": 0,
              "y": 0,
              "i": "explorer",
              "moved": false,
              "static": false
          }
      },
      {
          "key": "navigator",
          "show": false,
          "content": "Navigator",
          "scrollable": true,
          "title": "Navegador",
          "canClose": true
      },
      {
          "key": "editor",
          "show": true,
          "content": "FileTabs",
          "scrollable": true,
          "title": "Editor",
          "canClose": false,
          "dataGrid": {
              "w": 5,
              "h": 29,
              "x": 3,
              "y": 0,
              "i": "editor",
              "moved": false,
              "static": false
          }
      },
      {
          "key": "properties",
          "show": true,
          "content": "FilePropertiesWrapper",
          "scrollable": true,
          "title": "Propiedades",
          "canClose": false,
          "dataGrid": {
              "w": 3,
              "h": 20,
              "x": 0,
              "y": 9,
              "i": "properties",
              "moved": false,
              "static": false
          }
      }
  ],
  "xxs": [
      {
          "key": "explorer",
          "show": false,
          "content": "ProjectExplorer",
          "scrollable": true,
          "title": "Explorador",
          "canClose": true
      },
      {
          "key": "navigator",
          "show": false,
          "content": "Navigator",
          "scrollable": true,
          "title": "Navegador",
          "canClose": true
      },
      {
          "key": "editor",
          "show": true,
          "content": "FileTabs",
          "scrollable": true,
          "title": "Editor",
          "canClose": false,
          "dataGrid": {
              "w": 4,
              "h": 18,
              "x": 0,
              "y": 0,
              "i": "editor",
              "moved": false,
              "static": false
          }
      },
      {
          "key": "properties",
          "show": true,
          "content": "FilePropertiesWrapper",
          "scrollable": true,
          "title": "Propiedades",
          "canClose": false,
          "dataGrid": {
              "w": 4,
              "h": 11,
              "x": 0,
              "y": 18,
              "i": "properties",
              "moved": false,
              "static": false
          }
      }
  ]
}